/** @deprecated this is moved to libs */
export enum MileageCarEnum {
    LessThen15000 = '14998',
    Between15000And25000 = '24998',
    MoreThen25000 = '25001',
}
